import { gt, lt } from './util';

export const Angle = {
  PI_16: Math.PI/16,
  PI_8: Math.PI/8,
  PI_7: Math.PI/7,
  PI_6: Math.PI/6,
  PI_5: Math.PI/5,
  PI_4: Math.PI/4,
  PI_3: Math.PI/3,
  PI_2: Math.PI/2,
  PI: Math.PI,
  TWO_PI: 2*Math.PI
}

/**
 * normalize angle range to [0 to 2*PI)
 * @param theta angle
 */
export function normalizeAngle(theta: number): number {
  //            theta -  Angle.TWO_PI * Math.floor((theta + Angle.PI) / Angle.TWO_PI)

  // const angletheta -  Angle.TWO_PI * Math.trunc(theta / Angle.TWO_PI)
  const angle = theta - (Angle.TWO_PI * Math.trunc(theta / Angle.TWO_PI))


  if (angle < 0) {
    return angle + Angle.TWO_PI;
  }

  return angle
}

/**
 * normalize angle range to (-PI to PI]
 * @param theta angle
 */
export function normalizeAngleSigned(theta: number): number {
  const angle = normalizeAngle(theta)
  if (angle > Angle.PI) {
    return angle - Angle.TWO_PI
  }

  return angle
}

export function angleBetween(angle: number, theta0: number, theta1: number): boolean {
  const angle0 = normalizeAngle(angle)
  const _theta0 = normalizeAngle(theta0)
  const _theta1 = normalizeAngle(theta1)

  if (_theta1 > _theta0) {
    return (gt(angle0, _theta0) && lt(angle0, _theta1))
  } else {
    return (gt(angle0, _theta0) || lt(angle0, _theta1))
  }
}